import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import SplashScreen from 'components/SplashScreen';
import { setUserData, logout } from 'actions/accountActions';
import authService from 'services/authService';

function Auth({ children }) {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      authService.setAxiosInterceptors({
        onLogout: () => dispatch(logout())
      });

      authService.handleAuthentication();

      if (authService.isAuthenticated()) {
        try {
          const user = await authService.loginInWithToken();

          await dispatch(setUserData(user));
        } catch (err) {
          console.error('Silent login failed', err);
          authService.logout();
        }
      }

      setLoading(false);
    };

    initAuth();
  }, [dispatch]);

  if (isLoading) {
    return <SplashScreen/>;
  }

  return children;
}

Auth.propTypes = {
  children: PropTypes.any
};

export default Auth;
